'use client';

import React__default from 'react';
import { colors } from '../../Colors/index.js';

var CloseIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c, _d = _a.color, color = _d === void 0 ? colors.grey[50] : _d;
    return (React__default.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 24 24', fill: 'none' },
        React__default.createElement("path", { d: 'M4.9411 4C4.70027 4 4.45942 4.09197 4.27565 4.27574C3.90812 4.64326 3.90812 5.23909 4.27565 5.60662L10.6691 12L4.27565 18.3934C3.90812 18.7609 3.90812 19.3567 4.27565 19.7243C4.45965 19.9083 4.70015 20 4.9411 20C5.18204 20 5.42255 19.9083 5.60655 19.7243L12 13.3309L18.3935 19.7243C18.5775 19.9083 18.818 20 19.0589 20C19.2998 20 19.5403 19.9083 19.7243 19.7243C20.0919 19.3567 20.0919 18.7609 19.7243 18.3934L13.3309 12L19.7243 5.60662C20.0919 5.23909 20.0919 4.64326 19.7243 4.27574C19.3568 3.90821 18.761 3.90821 18.3935 4.27574L12 10.6691L5.60655 4.27574C5.42278 4.09197 5.18192 4 4.9411 4Z', fill: color })));
};
var CloseIcon$1 = React__default.memo(CloseIcon);

export { CloseIcon$1 as default };
//# sourceMappingURL=Close.js.map
